import { render, staticRenderFns } from "./SalSobCfg.vue?vue&type=template&id=45b7448f&scoped=true"
import script from "./SalSobCfg.vue?vue&type=script&lang=js"
export * from "./SalSobCfg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b7448f",
  null
  
)

export default component.exports